import * as Yup from 'yup'

const digitsOnly = (value) => /^\d+$/.test(value)

export const LoginSchema = Yup.object().shape({
  email: Yup.string().email('Please specify a valid email.').required('This field is required.'),
  password: Yup.string().required('This field is required.')
})

export const HealthSystemSchema = Yup.object().shape({
  name: Yup.string().required('This field is required.')
})

export const EmailSchema = Yup.object().shape({
  email: Yup.string().email('Please specify a valid email.').required('This field is required.')
})

export const RuleActionSchema = Yup.object().shape({
  selector: Yup.array().length(1, 'Please select an action to add.').required('This field is required.')
})

export const ValidateCodeSchema = Yup.object().shape({
  code: Yup.string().test('Digits only', 'This field should have digits only.', digitsOnly).required('This field is required.')
})

export const PasswordSchema = Yup.object().shape({
  password: Yup.string().required('This field is required.').matches(
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
    'Your password must be at least 8 characters long, contain at least one number, one special character, and have a mixture of uppercase and lowercase letters.'
  ),
  verifyPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords do not match.').required('Required')
})

export const ActionSchema = Yup.object().shape({
  narrative: Yup.string().required('This field is required.'),
  description: Yup.string().required('This field is required.'),
  actionType: Yup.number().positive('This field is required.')
})

export const SearchSchema = Yup.object().shape({
  startDate: Yup.date().required('The start date is required.'),
  endDate: Yup.date().required('The end date is required.')
})